const PRODUCTION_API_URL = "https://api.lust-an-zukunft.de";

const normalizeUrl = (value: string | undefined): string => (value || "").replace(/\/$/, "");

export const isProductionEnvironment = (): boolean => normalizeUrl(process.env.GATSBY_API_URL) === PRODUCTION_API_URL;
